import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '@core/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, Subscription} from 'rxjs';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordResetComponent implements OnInit, OnDestroy {

    // Form.
    form: FormGroup;
    token: string = null;

    // States.
    isLoading$ = new BehaviorSubject(false);

    // Subscriptions.
    private _subscription: Subscription;

    constructor(private _router: Router,
                private _auth: AuthService,
                private _route: ActivatedRoute) {
    }

    get password() {
        return this.form.get('password');
    }

    ngOnInit() {
        // Get the validators.
        const required = Validators.required;
        const minLength = Validators.minLength(6);

        // Build the form.
        this.form = new FormGroup({
            password: new FormControl('', [required, minLength])
        });

        this._subscription = this._route.queryParams.subscribe(params => {
            const token = params['token'];

            if (!token) {
                return this._router.navigate(['/admin/auth']);
            }

            this.token = token;
        });
    }

    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

    async tryToResetPassword() {
        // Set the button to display a busy state.
        this.isLoading$.next(true);

        // Try to reset the password.
        await this._auth.reset(this.token, this.password.value);

        // Route the user to the login section
        // based on the route data.
        const url = this._route.snapshot.data.redirectUrl || '/';
        await this._router.navigate([url]);
    }

}
